import React, { useState, useEffect } from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/row';
import Col from 'react-bootstrap/Col';
import { useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from '../Components/Header/Header';
import { Leftmenu } from '../Components/Leftmenu/Leftmenu';
import { FooterNavigation } from '../Components/FooterNavigationMobileView/FooterNavigation'
import { SearchCompany } from '../Components/Search_Company_Input/SearchCompany'
import { MobileHeader } from '../Components/Header/MobileViewHeader/MobileHeader';
import { CommonBaseURl } from '../Commonprovider/CommonProvider';
import { setCurrencyconvert, setReportAnalysis } from '../Redux/Slices/CommonLocalRedux/CommonSliceStorage'
import { useDispatch } from 'react-redux';
export const Mainlayout = () => {
    const location = useLocation()
    const [BaseURL] = useState(CommonBaseURl)
    const TopNavigateTap = useSelector(state => state.Navigation.Topnavigate)

    const dispatch = useDispatch()
    const Token = useSelector(state => state.Authenticationapi.token)
    const Currencyval = useSelector(state => state.LocalValuesData.Currencyvalue)
    const UserDetails = useSelector(state => state.LoginUserDetails.data)
    const [notfoundpage, setnotfoundpage] = useState('')
    const [width, setWidth] = useState(0);
    const Co_Code = useSelector(state => state.LocalValuesData.SelectedCompany[0]?.Co_Code)
    const Co_Code_Indus = useSelector(state => state.LocalValuesData.SelectedIndustry[0]?.Code || state.LocalValuesData.SelectedIndustry[0]?.Industry_Code)
    const Co_Code_House = useSelector(
        (state) =>
            state.LocalValuesData.SelectedHouse[0]?.Code ||
            state.LocalValuesData.SelectedHouse[0]?.House_Code
    );
    const ExportDetails = useSelector(state => state.LocalValuesData.ExportDetails)
    const Export = useSelector(state => state.LocalValuesData.Export)
    const Exported = useSelector(state => state.LocalValuesData.exported)
    const loginType = useSelector(state => state.LocalValuesData.loginType)
    let lastURL = window.location.href
    const PageName = useSelector(state => state.Navigation.PageName)
    const GetCurrencyValues = () => {
        if (Token != null) {
            fetch(`${BaseURL}GetCurrencyValues?code=${Currencyval}`, {
                method: "GET",
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    Authorization: "Bearer " + Token.access_token,
                },
            })
                .then((response) => response.json())
                .then((json) => {
                    let data = JSON.parse(json);
                    dispatch(setCurrencyconvert(data[0]?.CURR_RATE));
                });
        }
    };

    const ShowReportAnalysis = () => {
        if (Token != null) {
            fetch(`${CommonBaseURl}getIsAWSReportAnalysisFeature`, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                    'Authorization': 'Bearer ' + Token.access_token,
                }
            })
                .then((response) => response.json())
                .then((json) => {
                    const data = JSON.parse(json);
                    dispatch(setReportAnalysis(data[0]?.IsActive || 0))
                });
        }
    }

    useEffect(() => {
        ShowReportAnalysis()
    }, [])

    useEffect(() => {
        GetCurrencyValues()
        let Getpagenotfound = document.getElementsByClassName('notfound')
        if (Getpagenotfound.length == 1) {
            setnotfoundpage(false)
        } else {
            setnotfoundpage(true)
        }
    }, [Currencyval])

    useEffect(() => {
        if (location && location.pathname && !location.pathname.startsWith('/tp-screener') && !location.pathname.startsWith('/e-magazine')) {
            sessionStorage.setItem('main_app_last_url', location.pathname + location.search);
            sessionStorage.setItem('main_app_top_nav', JSON.stringify(TopNavigateTap));
        }
    }, [location.pathname, location.search, TopNavigateTap]);



    useEffect(() => {
        // fetchData();
        let code
        if (TopNavigateTap[1] == 'Company') {
            code = Co_Code
        } else if (TopNavigateTap[1] == 'Industry') {
            code = Co_Code_Indus
        } else if (TopNavigateTap[1] == 'House') {
            code = Co_Code_House
        } else {
            code = ""
        }
        debugger
        const newParams = {
            "test": "Abc",
            "pageName": lastURL,
            "Coccode": code || '',
            "IpAdd": "",
            "ScreenerQuery": "",
            "userid": UserDetails[0].UserId || JSON.parse(UserDetails)[0].UserId,
            "username": UserDetails[0].UserName || JSON.parse(UserDetails)[0].UserName,
            "ModuleName": PageName || "Company",
            "Export": !ExportDetails.export ? 0 : 1,
            "size": ExportDetails.size,
            "test2": "Abc"
        };
        fetch(`${CommonBaseURl}UserLogsRJS`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: `Bearer ${Token.access_token}`,
            },
            body: new URLSearchParams(newParams).toString(),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                let usserlog = data;
            })
            .catch((error) => {
                console.error("Error fetching matched companies:", error);
            });
        // }
    }, [Co_Code, lastURL, PageName, Exported, Co_Code_Indus, Co_Code_House]);

    return (
        <>
            <Header />
            <main>
                <div className='main_body'>
                    <Leftmenu setWidth={setWidth} />
                    <div className='landings-main'>
                        <Container fluid>
                            <Row>
                                <Col>
                                    <MobileHeader />
                                    {TopNavigateTap[1] != 'Ipo' && TopNavigateTap[1] != 'FactSheet' && TopNavigateTap[1] != 'Add-Ons' && TopNavigateTap[1] != 'CM- Live News' && TopNavigateTap[1] != 'Screener' && notfoundpage != false && TopNavigateTap[1] != 'Reports & Analytics' && (
                                        <SearchCompany width={width} />
                                    )}
                                    <Outlet />
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            </main>
            <FooterNavigation />
        </>
    )
}
